import React from 'react';
import { ArrowRight } from '@phosphor-icons/react';

const STEPS = [
  { n: 1, text: 'Crea las preguntas de cada curso' },
  { n: 2, text: 'Agrúpalas en baterías' },
  { n: 3, text: 'Arma el Banco de Preguntas' },
  { n: 4, text: 'Asígnalo a cada capacitación' },
];

export const ProcessGuide = ({ activeStep }) => {
  return (
    <div className="rounded-xl border border-[#2BBAA4]/20 bg-[#2BBAA4]/5 px-4 py-3" data-testid="process-guide">
      <p className="text-xs font-semibold text-[#2B4B8C]/70 mb-2 uppercase tracking-wide">Flujo del proceso</p>
      <div className="flex flex-wrap items-center gap-y-2">
        {STEPS.map((s, i) => (
          <div key={s.n} className="flex items-center">
            <div className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-xs sm:text-sm ${activeStep === s.n ? 'bg-[#2BBAA4] text-black font-semibold' : 'bg-white text-[#2B4B8C]/70 border border-[#2B4B8C]/10'}`}>
              <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold ${activeStep === s.n ? 'bg-black/10 text-black' : 'bg-[#2B4B8C]/10 text-[#2B4B8C]'}`}>{s.n}</span>
              <span>{s.text}</span>
            </div>
            {i < STEPS.length - 1 && <ArrowRight size={16} className="mx-1.5 text-[#2B4B8C]/30 shrink-0" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessGuide;
